<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ restaurant.title }}</strong>
                    <RestaurantTableOrderBadge />
                </CCardHeader>
                <CCardBody>
                    <RestaurantsTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <label v-if="adminOnly">Название <span class='label' > * </span></label>
                        <CInput
                            v-if="adminOnly"
                            v-model="restaurant.title"
                            placeholder="Введите название ресторана"
                            />

                        <label v-if="adminOnly">Код <span class='label' > * </span></label>
                        <CInput
                            v-if="adminOnly"
                            v-model="restaurant.code"
                            placeholder="Введите код" />
                        <CInput
                            v-if="adminOnly"
                            v-model="restaurant.legal_entity"
                            label="Юр. лицо"
                            placeholder="ООО…" />
                        <CInput v-if="adminOnly" v-model="computedCode" type="hidden" />
                        <CInput
                            v-if="adminOnly"
                            v-model="restaurant.short_title"
                            label="Короткое название"
                            placeholder="Введите короткое название ресторана" />
                        <CInput
                            v-if="adminOnly"
                            v-model="restaurant.alias"
                            label="Алиас"
                            placeholder="Введите алиас" />
                        <CTextarea
                            v-model="restaurant.description"
                            label="Краткое описание"
                            placeholder="Укажите краткое описание (не более 255 символов)" />
                        <CTextarea
                            v-model="restaurant.synonyms"
                            label="Синонимы"
                            placeholder="Укажите синонимы для поиска" />
                        <CSelect
                            v-if="adminOnly"
                            class="mb-3"
                            label="Башня"
                            placeholder="Башня..."
                            :options="towers"
                            :value.sync="restaurant.tower" />
                        
                        <div class="form-group">
                            <label>Типы кухни</label>
                            <div class="d-flex flex-wrap mb-2">
                                <CBadge 
                                    v-for="(type, index) in selectedCuisineTypes" 
                                    :key="index" 
                                    color="info" 
                                    class="mr-1 mb-1 p-2">
                                    {{ type.name }}
                                    <CButton 
                                        size="sm" 
                                        color="light"
                                        class="ml-1 p-0" 
                                        style="width: 20px; height: 20px; border-radius: 50%;"
                                        @click="removeCuisineType(type.id)">
                                        &times;
                                    </CButton>
                                </CBadge>
                            </div>
                            <CSelect
                                class="mb-3"
                                placeholder="Выберите тип кухни..."
                                :options="availableCuisineTypes"
                                v-model="selectedCuisineTypeId"
                                @change="addCuisineType"
                            />
                            <div class="d-flex mb-3">
                                <CButton
                                    color="success"
                                    size="sm"
                                    @click="newCuisineTypeModal = true">
                                    Добавить новый тип кухни
                                </CButton>
                            </div>
                        </div>
                        
                        <div class="form-group">
                            <label>Категории ресторана</label>
                            <div class="d-flex flex-wrap mb-2">
                                <CBadge 
                                    v-for="(type, index) in selectedRestaurantTypes" 
                                    :key="`restaurant-type-${index}`" 
                                    color="primary" 
                                    class="mr-1 mb-1 p-2">
                                    {{ type.title }}
                                    <CButton 
                                        size="sm" 
                                        color="light"
                                        class="ml-1 p-0" 
                                        style="width: 20px; height: 20px; border-radius: 50%;"
                                        @click="removeRestaurantType(type.id)">
                                        &times;
                                    </CButton>
                                </CBadge>
                                <span v-if="!selectedRestaurantTypes.length">Не выбрано</span>
                            </div>
                            <CSelect
                                class="mb-3"
                                placeholder="Выберите категорию..."
                                :options="availableRestaurantTypes"
                                v-model="selectedRestaurantTypeId"
                                @change="addRestaurantType"
                            />
                        </div>
                        
                        <div class="overflow-hidden border border-gray-300 rounded-md p-2 mb-4">
                            <WorkingHours 
                                :working-hours="workingHours"
                                :service-type="'restaurant'"
                                @working-hours-update="fetch"
                            />
                            <CRow v-if="adminOnly">
                                <CCol
                                    tag="label"
                                    sm="3"
                                    class="col-form-label">
                                    Скрывать когда закрыт
                                </CCol>
                                <CCol sm="9">
                                    <CSwitch
                                        color="dark"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="restaurant.hide"
                                    />
                                </CCol>
                            </CRow>
                        </div>
                        <CRow v-if="adminOnly">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Убрать применение промокода
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.hide_promocode"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Множественные ингридиенты
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.multiple_ingridients"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Считать КБЖУ
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.counting_calories"
                                />
                            </CCol>
                        </CRow>
                        <!-- counting_calories -->
                        <CRow v-if="adminOnly">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Показывать на главной
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.show_main_page"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Время доставки
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.show_delivery_time"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Скрывать рейтинг
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.hide_rating"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Показывать популярные блюда в "профиле"
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.popular_profile"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Запрос времени приготовления
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.time_cooking_request"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Отключить применение тарифов по зонам</CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.delivery_zone_disabled"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Активен
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.enabled" />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Архив
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.archive" />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save">Сохранить</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                    <CButton
                        v-if="adminOnly"
                        color="danger"
                        class="mr-3"
                        @click="deleteModal = true">Удалить</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="deleteModal"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>
                        Вы действительно хотите удалить ресторан? Это действие
                        нельзя будет отменить.
                    </p>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="deleteModal = false">Отмена</CButton>
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="deleteRestaurant">Сохранить</CButton>
                </div>
            </template>
        </CModal>

        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="disabledModal"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>
                        Отключение сервиса по причине: <br> <strong>"указать причину"</strong> до <strong>"указать дату"</strong>.
                    </p>
                    <br>
                    <div>
                        <label>Причина отключения сервиса:</label>
                        <CInput
                            v-model="restaurant.why_is_it_off"
                            placeholder="Причина отключения"
                        />
                    </div>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="disabledModal = false">Отмена</CButton>
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="saveDisabledService">Сохранить</CButton>
                </div>
            </template>
        </CModal>
        
        <CModal
            title="Добавление нового типа кухни"
            :show.sync="newCuisineTypeModal"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <CInput
                        v-model="newCuisineTypeName"
                        label="Название типа кухни"
                        placeholder="Введите название"
                    />
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="newCuisineTypeModal = false">Отмена</CButton>
                    <CButton
                        color="success"
                        class="ml-3"
                        @click="createCuisineType">Создать</CButton>
                </div>
            </template>
        </CModal>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import RestaurantsTabLinks from '@/components/RestaurantsTabLinks';
    import WorkingHours from '@/components/WorkingHoursUpdate';
    import { translit } from '@/utils/translit';
    import { xssRegEx } from '@/utils/rules';
    import { BUSINESS_TYPE } from '@/utils/order';
    import { BUSINESS_LABEL } from '@/utils/servicesLabel'
    import moment from 'moment';

    export default {
        name: 'RestaurantEdit',

        components: {
            RestaurantsTabLinks,
            WorkingHours,
        },

        data() {
            return {
                schedule: undefined,
                enabledOnServer: false,
                restaurant: {
                    service_label: '',
                    id: 0,
                    code: '',
                    title: '',
                    short_title: '',
                    alias: '',
                    delivery_terminal_id: '',
                    description: '',
                    synonyms: '',
                    address: '',
                    picture: '',
                    square_picture: '',
                    delivery_picture: '',
                    tower: 0,
                    open_at: '',
                    close_at: '',
                    extended_schedule: false,
                    min_price: 0,
                    min_price_pickup: 0,
                    phone: '',
                    delivery_time: 0,
                    delivery_time_hour: 0,
                    max_delivery_time: 0,
                    max_delivery_time_hour: 0,
                    delivery_zone_disabled: false,
                    enabled: true,
                    archive: false,
                    hide: false,
                    show_delivery_time: true,
                    hide_rating: false,
                    position: 0,
                    calories_100g: false,
                    time_cooking_request: false,
                    is_new_label: false,
                    hide_promocode: false,
                    multiple_ingridients: false,
                    counting_calories: false,
                    show_main_page: false,
                    show_in_table_orders: false,
                    vegan_label: false,
                    verified_mircity_label: false,
                    show_additional_info: true,
                    dish_gift_label: false,
                    popular_profile: false,

                    why_is_it_off: '',
                    who_turned_off: '',
                    shutdown_date: '',

                    labels: {
                        choose: false,
                        glutenFree: false,
                        halal: false,
                        meatFree: false,
                        new: false,
                        popular: false,
                        post: false,
                        sugarFree: false,
                        vegan: false,
                        spicy: false,
                        recommended: false,
                        newYear: false,
                        friendship: false,
                    },
                    average_bill: 0
                },
                towers: [],
                deleteModal: false,
                BUSINESS_TYPE,
                workingHours: [],
                disabledModal: false,
                activityСheck: false,
                selectedCuisineTypes: [],
                availableCuisineTypes: [],
                selectedCuisineTypeId: null,
                selectedRestaurantTypes: [],
                availableRestaurantTypes: [],
                selectedRestaurantTypeId: null,
                newCuisineTypeModal: false,
                newCuisineTypeName: '',
            };
        },

        computed: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings'))
                    .is_business_admin;
            },
            computedCode() {
                if (!this.restaurant.code) {
                    this.restaurant.code = translit(this.restaurant.title ? this.restaurant.title : '');
                }
                return this.restaurant.code;
            },
        },

        async mounted() {
            await this.fetch();
        },  

        methods: {
            setSchedule(schedule) {
                this.schedule = schedule;
            },
            async fetch() {
                try {
                    this.allowedSave = false;
                    this.activityСheck = false;
                    const id = this.$route.params.id;
                    const restaurant = await Vue.axios.get('/restaurants/' + id);
                    this.restaurant = restaurant.data;
                    this.restaurant.hide_rating = !!this.restaurant.hide_rating;
                    this.restaurant.archive = !!this.restaurant.archive;

                    this.enabledOnServer = restaurant.data.enabled;
                    if (restaurant?.data?.workingHours.length != 0) {
                        this.workingHours = restaurant.data.workingHours;
                    }
                    if (restaurant?.data?.schedule.length != 0) {
                        this.schedule = restaurant.data.schedule;
                    }

                    if (!this.restaurant.labels) {
                        this.restaurant.labels = {
                            choose: false,
                            glutenFree: false,
                            halal: false,
                            meatFree: false,
                            new: false,
                            popular: false,
                            post: false,
                            sugarFree: false,
                            vegan: false,
                            spicy: false,
                            recommended: false,
                            newYear: false,
                            friendship: false,
                        }
                    }
                    
                    // Load cuisine types
                    const cuisineTypesResponse = await Vue.axios.get('/cuisine-types');
                    const allCuisineTypes = cuisineTypesResponse.data;
                    
                    // Get restaurant cuisine types
                    const restaurantCuisineTypesResponse = await Vue.axios.get(`/restaurants/${parseInt(id)}/cuisine-types`);
                    this.selectedCuisineTypes = restaurantCuisineTypesResponse.data;
                    
                    // Filter available cuisine types (those not already selected)
                    const selectedIds = this.selectedCuisineTypes.map(type => parseInt(type.id));
                    this.availableCuisineTypes = allCuisineTypes
                        .filter(type => !selectedIds.includes(parseInt(type.id)))
                        .map(type => ({
                            value: parseInt(type.id),
                            label: type.name,
                            id: parseInt(type.id),
                            name: type.name
                        }));

                    // Load restaurant types
                    const restaurantTypesResponse = await Vue.axios.get('/restaurant-types');
                    const allRestaurantTypes = restaurantTypesResponse.data || [];
                    const restaurantTypesSelectedResponse = await Vue.axios.get(`/restaurants/${parseInt(id)}/restaurant-types`);
                    this.selectedRestaurantTypes = restaurantTypesSelectedResponse.data || [];
                    const selectedRestaurantTypeIds = this.selectedRestaurantTypes.map(type => parseInt(type.id));
                    this.availableRestaurantTypes = allRestaurantTypes
                        .filter(type => !selectedRestaurantTypeIds.includes(parseInt(type.id)))
                        .map(type => ({
                            value: parseInt(type.id),
                            label: type.title,
                            id: parseInt(type.id),
                            title: type.title
                        }));
                } catch (error) {
                    this.$root.$emit('showError', `Ошибка загрузки данных. \n\n${error.response.data.error}`);
                }

                if (!this.towers.length) {
                    const towers = [{ value: null, label: 'Башня...' }];
                    const tows = await Vue.axios.get('/address')
                    tows.data.forEach(tower => {
                        towers.push({ value: tower.id, label: tower.name });
                    });
                    this.towers = towers;
                }
            },

            async save() {
                if (!this.restaurant.code) {
                    this.$root.$emit('showError', 'Укажите код.');
                    return;
                }
                if (!this.restaurant.title) {
                    this.$root.$emit('showError', 'Укажите название ресторана.');
                    return;
                }

                if (this.enabledOnServer && !this.restaurant.enabled && !this.allowedSave) {
                    this.disabledModal = true;
                    return;
                }

                if(this.restaurant.delivery_time === ''){
                    this.restaurant.delivery_time = 0;
                }

                if(this.restaurant.delivery_time_hour === ''){
                    this.restaurant.delivery_time_hour = 0;
                }

                this.restaurant.hide = !!this.restaurant.hide;
                this.restaurant.show_delivery_time = !!this.restaurant.show_delivery_time;
                this.restaurant.hide_rating = !!this.restaurant.hide_rating;
                this.restaurant.extended_schedule = !!this.restaurant.extended_schedule;
                this.restaurant.schedule = this.schedule;

                try {
                    let formData = new FormData();

                    this.restaurant.min_price = this.restaurant.min_price ? +this.restaurant.min_price : 0;
                    this.restaurant.min_price_pickup = this.restaurant.min_price_pickup ? +this.restaurant.min_price_pickup : 0;
                    this.restaurant.max_delivery_time = +this.restaurant.max_delivery_time ? +this.restaurant.max_delivery_time : null;
                    this.restaurant.max_delivery_time_hour = +this.restaurant.max_delivery_time_hour ? +this.restaurant.max_delivery_time_hour : null;
                    this.restaurant.delivery_time = this.restaurant.delivery_time ? +this.restaurant.delivery_time : 0;
                    this.restaurant.delivery_time_hour = this.restaurant.delivery_time_hour ? +this.restaurant.delivery_time_hour : 0;

                    this.restaurant.why_is_it_off = this.enabledOnServer && !this.restaurant.enabled && this.restaurant.why_is_it_off ? "" + this.restaurant.why_is_it_off : null;

                    // Update restaurant data
                    await Vue.axios.post('/restaurants/update/' + this.$route.params.id, this.restaurant);
                    
                    // Update cuisine types
                    const cuisineTypeIds = this.selectedCuisineTypes.map(type => type.id);
                    await Vue.axios.post(`/restaurants/${parseInt(this.$route.params.id)}/cuisine-types`, {
                        cuisineTypeIds
                    });
                    
                    const restaurantTypeIds = this.selectedRestaurantTypes.map(type => type.id);
                    await Vue.axios.post(`/restaurants/${parseInt(this.$route.params.id)}/restaurant-types`, {
                        typeIds: restaurantTypeIds
                    });

                    this.goBack();
                } catch (error) {
                    this.$root.$emit('showError', `Ошибка сохранения. \n\n${error.response.data.error}`);
                }
            },

            async saveDisabledService() {
                if (!this.restaurant.why_is_it_off && !this.restaurant.enabled) {
                    alert('Укажите причину отключения или редактирования');
                    return;
                }
                this.allowedSave = true;

                await this.save();
            },

            deleteRestaurant() {
                Vue.axios
                    .delete('/restaurants/' + this.restaurant.id)
                    .then(resp => {
                        this.$router.push({ path: '/restaurants' });
                    })
                    .catch(err => {
                        this.$root.$emit('showError', `Ошибка удаления. \n\n${err.response.data.error}`);
                    });
            },

            goBack() {
                this.$router.push({
                    path: '/restaurants/' + this.$route.params.id,
                });
            },

            addCuisineType() {
                const selectedType = this.availableCuisineTypes.find(type => type.value === this.selectedCuisineTypeId);
                if (selectedType) {
                    // Add to selected types
                    this.selectedCuisineTypes.push({
                        id: parseInt(selectedType.id),
                        name: selectedType.name
                    });
                    
                    // Remove from available types
                    this.availableCuisineTypes = this.availableCuisineTypes.filter(type => type.id !== selectedType.id);
                    
                    // Reset selection
                    this.selectedCuisineTypeId = null;
                }
            },

            removeCuisineType(id) {
                const typeToRemove = this.selectedCuisineTypes.find(type => type.id === id);
                if (typeToRemove) {
                    // Remove from selected
                    this.selectedCuisineTypes = this.selectedCuisineTypes.filter(type => type.id !== id);
                    
                    // Add back to available
                    this.availableCuisineTypes.push({
                        value: parseInt(typeToRemove.id),
                        label: typeToRemove.name,
                        id: parseInt(typeToRemove.id),
                        name: typeToRemove.name
                    });
                    
                    // Sort available types by name
                    this.availableCuisineTypes.sort((a, b) => a.name.localeCompare(b.name));
                }
            },

            addRestaurantType() {
                const selectedType = this.availableRestaurantTypes.find(type => type.value === this.selectedRestaurantTypeId);
                if (selectedType) {
                    this.selectedRestaurantTypes.push({
                        id: parseInt(selectedType.id),
                        title: selectedType.title
                    });
                    this.availableRestaurantTypes = this.availableRestaurantTypes.filter(type => type.id !== selectedType.id);
                    this.selectedRestaurantTypeId = null;
                }
            },

            removeRestaurantType(id) {
                const typeToRemove = this.selectedRestaurantTypes.find(type => type.id === id);
                if (typeToRemove) {
                    this.selectedRestaurantTypes = this.selectedRestaurantTypes.filter(type => type.id !== id);
                    this.availableRestaurantTypes.push({
                        value: parseInt(typeToRemove.id),
                        label: typeToRemove.title,
                        id: parseInt(typeToRemove.id),
                        title: typeToRemove.title
                    });
                    this.availableRestaurantTypes.sort((a, b) => a.title.localeCompare(b.title));
                }
            },

            async createCuisineType() {
                if (!this.newCuisineTypeName) {
                    alert('Укажите название типа кухни');
                    return;
                }

                try {
                    const response = await Vue.axios.post('/cuisine-types', {
                        name: this.newCuisineTypeName
                    });

                    if (response.data.id) {
                        const cuisineTypeId = parseInt(response.data.id);
                        this.availableCuisineTypes.push({
                            value: cuisineTypeId,
                            label: this.newCuisineTypeName,
                            id: cuisineTypeId,
                            name: this.newCuisineTypeName
                        });
                        this.newCuisineTypeName = '';
                        this.newCuisineTypeModal = false;
                    }
                } catch (error) {
                    this.$root.$emit('showError', `Ошибка создания типа кухни. \n\n${error.response.data.error}`);
                }
            },
        },
    };
</script>
<style>
.label
    {
    color: red;
    font-size: 150%
    }
</style>
